/**
 * Pure H OS · Sprint 6 · Finance OS shell.
 */
import { NavLink, Outlet } from "react-router-dom";
import {
  LayoutDashboard, TrendingUp, Receipt, Waves, Target,
  FileText, CreditCard, ShieldAlert, Wallet, HandCoins,
  Gavel, PieChart, BarChart3, ScrollText,
} from "lucide-react";

const SUBNAV = [
  { to: "overview",         label: "Overview",             icon: LayoutDashboard },
  { to: "invoices",         label: "Accounts Receivable",  icon: Receipt         },
  { to: "expenses",         label: "Accounts Payable",     icon: FileText        },
  { to: "business-reality", label: "Payments",             icon: HandCoins       },
  { to: "cash",             label: "Cash Flow",            icon: Waves           },
  { to: "budget",           label: "Budget",               icon: Target          },
  { to: "pnl",              label: "P&L",                  icon: BarChart3       },
  { to: "taxes",            label: "Taxes",                icon: Gavel           },
  { to: "cost-centers",     label: "Cost Centers",         icon: PieChart        },
  { to: "reports",          label: "Reports",              icon: ScrollText      },
  { to: "risks",            label: "Risks",                icon: ShieldAlert     },
];

export default function FinanceLayout() {
  return (
    <div data-testid="pureh-finance">
      <div className="mb-4">
        <div className="text-[10px] uppercase tracking-[0.24em] text-slate-500 mb-2 inline-flex items-center gap-1.5">
          <Wallet size={11} /> Finance OS
        </div>
        <h1 className="text-3xl font-semibold text-slate-900 tracking-tight">ORVAN Perfumes · Finance</h1>
      </div>

      <nav data-testid="finance-subnav" className="mb-6 -mx-1 overflow-x-auto">
        <div
          className="inline-flex items-center gap-1 p-1"
          style={{
            background: "var(--ph-surface)",
            border: "1px solid var(--ph-border-subtle)",
            borderRadius: "var(--ph-radius-md)",
          }}
        >
          {SUBNAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`fn-subnav-${item.to}`}
              className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium transition-colors"
              style={({ isActive }: { isActive: boolean }) => ({
                background: isActive ? "var(--ph-surface-card)" : "transparent",
                color: isActive ? "var(--ph-ink-strong)" : "var(--ph-ink-muted)",
                borderRadius: "var(--ph-radius-sm)",
                boxShadow: isActive ? "var(--ph-shadow-card)" : "none",
                border: isActive ? "1px solid var(--ph-border-subtle)" : "1px solid transparent",
              })}
            >
              <item.icon size={13} />
              {item.label}
            </NavLink>
          ))}
        </div>
      </nav>

      <Outlet />
    </div>
  );
}
